export default __webpack_public_path__ + "assets/images/cb1c3f61d5b9e1cf2db1e62eea5c4f29.webp";